import {useState} from 'react';
import GoogleMapReact from 'google-map-react';
import LocationMarker from './LocationMarker';
import LocationinfoBox from './LocationinfoBox';
const Map = ( {eventData,center,zoom}) => {

    const [locationInfo , setLocationInfo] = useState(null);

        const markers = eventData.map(ev => {
                if(ev.categories[0].id === 8){
                    return <LocationMarker 
                    lat={ev.geometries[0].coordinates[1]} 
                    lng = {ev.geometries[0].coordinates[0]}
                    onClick = { () => setLocationInfo({
                        id : ev.id,
                        title : ev.title
                    }) }   
                    />
                }
        })
    return (
        <div className="map">
            <GoogleMapReact
                bootstrapURLKeys = {{
                    key : 'AIzaSyCXgDJEyjMhboJiHk8vBbPcgHeV7oSd24E'
                }}
                defaultCenter = {center}
                defaultZoom = {zoom}
            >
             {markers}   


            </GoogleMapReact>
            {locationInfo && <LocationinfoBox info={locationInfo} /> }
        </div>
    )
}

Map.defaultProps = {
    center : {
        lat:19.601194,
        lng:75.552979
    },
    zoom : 2
}

export default Map;
